"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onDOMElementClick = exports.onDOMElementEnter = exports.onDOMElementLeave = exports.DOMElementType = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
exports.DOMElementType = Object.freeze({
    LineAnnotationMarker: 'LineAnnotationMarker',
});
exports.onDOMElementLeave = (0, toolkit_1.createAction)('ON_DOM_ELEMENT_LEAVE');
exports.onDOMElementEnter = (0, toolkit_1.createAction)('ON_DOM_ELEMENT_ENTER');
exports.onDOMElementClick = (0, toolkit_1.createAction)('ON_DOM_ELEMENT_CLICK');
//# sourceMappingURL=dom_element.js.map